module.exports = __webpack_public_path__ + "img/delivery.9e0dcd0f.svg";